const Footer = () => {
    return (
        <div className="footer-section">
            <img src= {'/images/pulse-logo.png'} alt="Pluse" />
            <p>Copyright © 2024 Pulse. All rights reserved.</p>
        </div>
    );
};

export default Footer;
